import React, { useContext, useEffect, useState, useRef } from 'react';
import { Navbar } from 'react-bootstrap';
import classNames from 'classnames';
import AppContext from 'context/Context';
import Logo from 'components/common/Logo';

import { navbarBreakPoint, topNavbarBreakpoint } from 'config';
import TopNavRightSideNavItem from './TopNavRightSideNavItem';
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';

const NavbarTop = ({ socket, establishment }) => {
  const {
    config: { showBurgerMenu, navbarPosition, navbarCollapsed },
    setConfig
  } = useContext(AppContext);

  const { pathname } = useLocation();
  const isChat = pathname.includes('chat');

  const [showDropShadow, setShowDropShadow] = useState(false);
  const burgerMenuRef = useRef(null);

  const handleBurgerMenu = () => {
    navbarPosition === 'top' && setConfig('navbarCollapsed', !navbarCollapsed);
    (navbarPosition === 'vertical' || navbarPosition === 'combo') &&
      setConfig('showBurgerMenu', !showBurgerMenu);
  };

  const setDropShadow = () => {
    const el = document.documentElement;
    if (el.scrollTop > 0) {
      setShowDropShadow(true);
    } else {
      setShowDropShadow(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', setDropShadow);
    return () => window.removeEventListener('scroll', setDropShadow);
  }, []);

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        burgerMenuRef.current &&
        !burgerMenuRef.current.contains(event.target)
      ) {
        if (!event.target.closest('.navbar-collapse')) {
          setConfig('showBurgerMenu', false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setConfig]);

  return (
    <Navbar
      className={classNames('navbar-glass  fs--1 navbar-top', {
        'navbar-glass-shadow': showDropShadow && !isChat
      })}
      expand={navbarPosition === 'top' ? topNavbarBreakpoint : true}
    >
      <Navbar.Toggle
        className={classNames('toggle-icon-wrapper me-md-3 me-2', {
          'd-lg-none': navbarPosition === 'top',
          [`d-${navbarBreakPoint}-none`]: false
        })}
        as="div"
        ref={burgerMenuRef}
      >
        <button
          className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center"
          onClick={handleBurgerMenu}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>
      </Navbar.Toggle>

      <div className="d-flex align-items-center">
        <Logo at="navbar-top" />
      </div>

      <TopNavRightSideNavItem socket={socket} establishment={establishment} />
    </Navbar>
  );
};

NavbarTop.propTypes = {
  socket: PropTypes.object,
  establishment: PropTypes.object
};

export default NavbarTop;
